<template>
  <span>
    <a-modal v-model="visible" width="660px" :mask-closable="false" title="导入用例" ok-text="确认" cancel-text="取消" :ok-button-props="{ props: { disabled: !fileList.length > 0 || hasError, loading: uploading } }" @ok="submitImport" @cancel="close">
      <span class="step-title">第一步：下载模板</span>
      <p>按照下载的模板格式填写用例信息</p>
      <p><a-button type="primary" icon="download" @click="onDownload"> 下载模板 </a-button></p>
      <span class="step-title">第二步：导入文件</span>
      <p>支持文件类型: xls、xlsx;</p>
      <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
        <a-button type="primary" icon="upload" :disabled="fileList.length > 0"> 选择文件 </a-button>
      </a-upload>
      <span v-if="errorCaught">
        <span style="color: red; font-size: 15px">部分用例校验失败: </span><br />
        <div v-for="(errInfo, i) in errorMsg" :key="i">
          <span>
            {{ errInfo.case }}: <span style="color: red">{{ errInfo.message }}</span>
          </span>
        </div>
        <p style="padding-top: 5px"><a-button v-if="receiptUri != null" type="primary" icon="download" @click="onDownloadReceipt"> 下载回执 </a-button></p>
      </span>
    </a-modal>
    <a-tooltip title="导入">
      <a-button v-tc="{ name: '导入' }" type="primary" icon="import" @click="onImport" />
    </a-tooltip>
  </span>
</template>
<script>
import { caseCheck, caseImport } from '@/api/project/case';

export default {
  props: {
    moduleId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      fileList: [],
      visible: false,
      uploading: false,
      projectId: parseInt(this.$route.params.project_id) || null,
      errorCaught: false,
      errorMsg: [],
      receiptUri: null,
      hasError: false
    };
  },
  watch: {
    fileList: {
      immediate: true,
      handler: function (value) {
        if (value.length > 0) {
          const formData = new FormData();
          formData.append('file_data', value[0]);
          formData.append('project_id', this.projectId);
          formData.append('module_id', this.moduleId);
          caseCheck(formData).then(res => {
            if (res.code !== 2000) {
              this.errorCaught = true;
              this.errorMsg = res.message;
              this.receiptUri = res.data.receiptUrl;
              this.hasError = true;
            } else {
              this.$message.success('case检查成功, 请继续上传');
            }
          });
        }
      }
    }
  },
  methods: {
    close() {
      this.visible = false;
      this.uploading = false;
      this.fileList = [];
      this.errorCaught = false;
      this.errorMsg = [];
      this.receiptUri = null;
      this.hasError = false;
      this.$emit('close');
    },

    onDownload() {
      window.open(process.env.VUE_APP_RESOURCE_URL + '/documents/%E6%B5%8B%E8%AF%95%E7%94%A8%E4%BE%8B%E6%A8%A1%E6%9D%BF.xlsx');
    },

    onDownloadReceipt() {
      window.open(this.receiptUri);
    },

    onImport() {
      this.visible = true;
    },

    beforeUpload(file) {
      this.fileList = [...this.fileList, file];
      return false;
    },

    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },

    submitImport() {
      this.uploading = true;
      const formData = new FormData();
      formData.append('file_data', this.fileList[0]);
      formData.append('project_id', this.projectId);
      formData.append('module_id', this.moduleId);
      caseImport(formData)
        .then(res => {
          if (res.code !== 2000) {
            this.errorCaught = true;
            this.errorMsg = res.message;
            this.receiptUri = res.data.receiptUrl;
            this.uploading = false;
          } else {
            this.uploading = false;
            this.$message.success('上传成功');
            this.close();
          }
        })
        .catch(() => {
          this.uploading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.step-title {
  display: block;
  font-weight: bold;
  line-height: 24px;
}
</style>
